<template>
    <div>
    <div style="height: 100vh; width: 100%">
        <l-map ref="myMap" :zoom="zoom" :center="center" :options="mapOptions">
        <l-control-scale position="bottomleft" :maxWidth=150 :imperial="false"></l-control-scale>
        <l-aircraft v-if="('alive' in this.aircraft)"
        :addr="aircraft.addr"
        :type="aircraft.type"
        :lat-lng="aircraft.position"
        :lat-lngs="aircraft.polyline"
        :alive="aircraft.alive"
        :rotate="aircraft.rotate"
        :select="true"
        :wpath=2.5
        :vpath="aircraft.vpath"
        v-on:aircraft:select="evt($event)"
        />
        <l-control :position="'topcenter'">
            <button class="btn btn-action" v-on:click="$router.go(-1)">
                <i class="icon icon-back"></i>
            </button>
        </l-control>
        <l-control-layers :position="'topleft'" />
        <l-tile-layer
            v-for="layer in layers"
            :key="layer.name"
            :url="layer.url"
            :name="layer.name"
            :options="layer.options"
            :attribution="layer.attribution"
            :visible="layer.visible"
            layer-type="base"
        />
        <l-control class="custom-control">
            <div v-if="('alive' in this.aircraft)" class=select>
                <div class="center">
                    <div><b>{{aircraft.reg}}</b></div>
                    <u>Last Signal (UTC)</u>:
                    <div><b>{{aircraft.utc}}</b></div>
                </div>
                <div><u>Lat</u>: <b>{{aircraft.lat_dms}}</b></div>
                <div><u>Lng</u>: <b>{{aircraft.lng_dms}}</b></div>
                <div><u>Elev (QNH)</u>: <b>{{altconv(aircraft.alt, this.imperial)}}</b></div>
                <div><u>Speed</u>: <b>{{gspconv(aircraft.gsp, this.imperial)}}</b></div>
                <div><u>Climb Rate</u>: <b>{{clrconv(aircraft.clr, this.imperial)}}</b></div>
                <div><u>Signal State</u>:
                  <div class="circle" :style="{backgroundColor: color}"></div>
                  <b><span :style="{color: color}"> {{this.state}}</span></b>
                </div>
                <div v-if="igcshow" class="center"><span class="label label-rounded label-primary c-hand" @click="igc(aircraft)">igc</span></div>

            </div>
            <div v-if="!('alive' in this.aircraft)" class="no-activity">
                <div>{{(this.$route.params.address).toUpperCase()}}</div>
                <div>Not Found</div>
            </div>
        </l-control>
        </l-map>
    </div>
    </div>
</template>

<script>
import { Icon } from 'leaflet';
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

import { altconv, gspconv, clrconv } from '@/utils/external.js'
import { LMap, LControl, LControlLayers, LTileLayer, LControlScale} from 'vue2-leaflet';
import LAircraft from '@/components/aircraft.vue';
import { latLng } from "leaflet";
import axios from 'axios';

const api_url = process.env.VUE_APP_LIVEURL
let interval=""
let polling_time=5000
let error_time=2000

export default {
    name: 'Sar',
    components: {
                LMap,
                LAircraft,
                LControl,
                LControlLayers,
                LTileLayer,
                LControlScale
    },
    data () {
        return {
            mapOptions: {
                zoomSnap: 0.5,
                zoomControl: false
            },
            imperial: false,
            zoom: 12,
            center: latLng(47.79861666666667, 3.7813333333333334),
            aircraft: {},
            layers: [
                {
                    name: 'Esri',
                    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
                    options: {maxNativeZoom: 15},
                    attribution: '<a href="http://www.esri.com/" target="_blank">Esri</a>',
                    subdomains: 'a,b,c',
                    visible: false
                },
                {
                    name: 'Stamen',
                    url: 'https://tiles.stadiamaps.com/tiles/stamen_terrain/{z}/{x}/{y}{r}.png',
                    options: {maxNativeZoom: 12},
                    attribution: '&copy; <a href="https://stadiamaps.com/" target="_blank">Stadia Maps</a> &copy; \
                    <a href="https://stamen.com/" target="_blank">Stamen Design</a> &copy; \
                    <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> &copy; \
                    <a href="https://www.openstreetmap.org/about" target="_blank">OpenStreetMap</a> contributors',
                    visible: false
                },
                {
                    name: 'OpenTopoMap',
                    url: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
                    attribution: '<a href="http://opentopomap.org" target="_blank">OpenTopoMap</a>',
                    options: {maxNativeZoom: 15},
                    subdomains: 'a,b,c',
                    visible: false
                },
                {
                    name: 'OpenStreetMap',
                    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                    attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a>',
                    visible: true
                }
            ],
        }
    },
    computed: {
        state () {
                  return (this.aircraft.alive ? "Online" : "Offline")
        },
        color () {
               return (this.aircraft.alive ? '#7a7acf' : 'red')
        },
        igcshow () {
            // boolean for igc download button (api will no given igc for more than 24 hours)
            return (Date.now()/1000 <= this.aircraft.tsp + 86400)
        }
    },
    mounted (){
        this.imperial = this.$store.getters.imperial
        this.address = this.$route.params.address
        this.polling(true)
        interval = setInterval(function (){this.polling(false)}.bind(this), polling_time)
    },
    beforeDestroy () {
        clearInterval(interval)
    },
    methods: {
            evt(evt) {
                this.aircraft.select = true
                this.path(evt)
                this.aircraft.vpath = !this.aircraft.vpath
            },
            polling(init_){
                var init = init_
                let prom = axios.get([api_url, 'address', this.address].join('/'), {timeout: error_time})
                prom
                .then (response => {
                    let data = response.data
                    let ret = Object.assign({}, data)
                    ret['rotate'] = data.track
                    ret['position'] = latLng(data.lat, data.lng)
                    if (init){
                        ret['vpath'] = false
                        ret['polycomplete'] = false
                        ret['polyline'] = [[data.lat, data.lng]]
                        this.$refs.myMap.mapObject.panTo(ret['position'])
                    }
                    else{
                        ret['polyline'] = this.aircraft.polyline
                        let old_lat = this.aircraft.position.lat
                        let old_lng =  this.aircraft.position.lng
                        if ((old_lat != data.lat)&&(old_lng != data.lng)){
                            ret['polyline'].push([data.lat, data.lng])
                        }
                        ret['select'] = this.aircraft.select
                        ret['vpath'] = this.aircraft.vpath
                        ret['polycomplete'] = this.aircraft.polycomplete
                    }
                    this.aircraft = ret
                })
                .catch(error => {
                    console.log("Error while consuming live address Api:" + error)
                })
            },
            path(addr){
                if (this.aircraft.polycomplete) return
                let prom = axios.get([api_url, 'path', addr, '0'].join('/'), {timeout: error_time})
                prom.then (response => {
                    let data = response.data
                    if (data !== null && data.poly) {
                        this.aircraft.polycomplete = true
                        let new_poly = data.poly.concat(this.aircraft.polyline)
                        this.aircraft.polyline = new_poly
                    }
                })
                .catch(error => {console.log("Error while consuming live path Api:" + error)})
            },
            igc(aircraft){
                let address = aircraft.addr
                let registration_ = aircraft.reg
                let igc_filename = `sar`
                if (registration_) igc_filename += `${registration_}.`
                if ((address.charAt(0) === '~') || (address.charAt(0) === '_'))  igc_filename += `#${address.slice(-5)}.igc`
                else igc_filename += `${address}.igc`
                axios
                .get([api_url, 'igc',address, 0].join('/'))
                .then(response => {
                    const blob = new Blob([response.data], { type: 'text/plain' })
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob)
                    link.download = igc_filename
                    link.click()
                    URL.revokeObjectURL(link.href)
                    }).catch(console.error)
            },
            altconv: altconv,
            gspconv: gspconv,
            clrconv: clrconv
    }
}
</script>

<style>
div.leaflet-top, div.leaflet-bottom {
    position: absolute;
    z-index: 400;
    pointer-events: none;
}
.leaflet-control-scale {
    background-color: white;
}
.leaflet-control-layers label {
    display: block;
    text-align: left;
}
.circle {
    width: 10px;
    height: 10px;
    border-radius: 5px;
    display: inline-block;
}
.center {
  text-align: center;
}
.custom-control {
  background: #fff;
  border: 2px solid rgba(0,0,0,.2);
  border-radius: 0.5em;
  width: 150px;
  text-align: left;
}
.select {
    padding: 0.5em 0.5em;
}
.no-activity {
    text-align: center;
    color: red;
    font-weight: bold;
    background-color:orange;
    border-radius: 0.5em;
    padding-top: 3px;
    padding-bottom: 3px;
}
</style>